import { Modal, Utils } from 'common';
import React, { useContext } from 'react';
import {
	WrappedButton,
	WrappedButtonType,
} from 'ui/button/WrappedButton.component';
import ReactivatePlanModal from '../subscriptionPlan/ReactivatePlanModal.component.js';
import ReactivationSuccessfulModal from '../subscriptionPlan/ReactivationSuccessfulModal.component';
import AccountCommunication from './../utils/AccountCommunication';
import { RoutePath } from '../utils/RoutePath';
import { PendingPlanClosingFineprint } from './PendingPlanClosingDisclaimer.component';
import PlanDetailsModal from './PlanDetailsModal.component.js';

const { ModalContext } = Modal;
const {
	Logger: { logToServer },
	Session,
	Util,
	BillingPlans,
	Communication,
	Analytics,
} = Utils;

const { prettyPrintPlan } = BillingPlans;

export const PlanTile = ({
	mobileCls,
	index,
	selectedPlan,
	planName,
	description,
	price,
	pricePeriod,
	summary,
	isInProgress,
	onSelectPlan,
	nextBillingDate,
	closeRequestedDate,
	history,
}) => {
	const { showModal } = useContext(ModalContext);
	const { BillingDayOfMonth } = Session.getInternalAccountInfo();

	const launchDetailsModal = e => {
		e.stopPropagation();

		showModal({
			component: PlanDetailsModal,
			data: {
				description,
			},
		});

		logToServer({
			category: 'View Details',
			Plan: planName,
		});
	};

	const onSelectPlanWrapper = () => {
		onSelectPlan(index);
	};

	const onReactivatePlan = async () => {
		history.push(RoutePath.changePlan);
		const reactivatePlan = async () => {
			Analytics.trackEvent(
				'reactivate_plan',
				{ type: 'confirm' },
				Analytics.agent.segment
			);

			AccountCommunication.reactivatePlan().then(async response => {
				if (Communication.isSuccessful(response)) {
					await Session.loadAccountInfo();
					// tested
					const reactivationModalId = showModal({
						component: ReactivationSuccessfulModal,
						data: {
							onConfirm: () => {
								history.push(RoutePath.changePlan);
							},
						},
					});
				} else {
					Communication.showError(response.message);
				}
			});
		};

		Analytics.trackEvent(
			'reactivate_plan',
			{ type: 'click' },
			Analytics.agent.segment
		);

		showModal({
			component: ReactivatePlanModal,
			data: {
				onConfirm: reactivatePlan,
			},
		});
	};

	const isSelected = selectedPlan ? ' selected' : '';
	const isCurrentPlan = index === 0 ? 'Current Plan' : '';
	const isPlanInProgress = isInProgress
		? `New Plan (Starting ${Util.getBillingDate(BillingDayOfMonth)})`
		: '';

	return (
		<div
			className={`account-plan-tile${isSelected}${mobileCls}`}
			onClick={onSelectPlanWrapper}
			role="button"
			tabIndex={0}
		>
			<div className={`plan-name${mobileCls}`}>{prettyPrintPlan(planName)}</div>
			<div className="plan-info">
				<div className="plan-type">{isCurrentPlan || isPlanInProgress}</div>
				<div className="plan-cost">
					{`$${price} ${pricePeriod}*`}
					<a
						className="details"
						role="button"
						tabIndex={0}
						onClick={launchDetailsModal}
					>
						View Details
					</a>
				</div>
				<p>{summary}</p>
				{closeRequestedDate && isCurrentPlan && (
					<>
						<div className="pending-plan-closing-fineprint">
							<PendingPlanClosingFineprint nextBillingDate={nextBillingDate} />
						</div>
						<div className="reactivate-plan-button">
							<WrappedButton
								label="Reactivate Plan"
								buttonType={WrappedButtonType.Primary}
								onClick={onReactivatePlan}
								dataqa="reactivate-plan"
							/>
						</div>
					</>
				)}
			</div>
		</div>
	);
};
